import axios from 'axios';

export default {
    pre_insercion(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_sinpp_contactos.pre_insercion_ConPol",
				"p_args_in": JSON.stringify({
                    "p_usuario": p_usuario,
				  })
			})
	},

	consulta_poliza(p_email, p_ejecutivo, p_poliza){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_sinpp_contactos.fnc_consultaPoliza",
			"p_args_in": JSON.stringify({
				"p_ejecutivo": p_ejecutivo,
				"p_poliza": p_poliza,
			  })
		})
	},

	consulta_contratante(p_email, p_contratante){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_sinpp_contactos.fnc_consultacontratante",
			"p_args_in": JSON.stringify({
				"p_contratante": p_contratante,
				})
		})
	},
	consulta_corredor(p_email, p_corredor){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_sinpp_contactos.fnc_consultaCorredor",
			"p_args_in": JSON.stringify({
				"p_codcorredor": p_corredor,
				})
		})
	},

	recuperar(p_email, p_ejecutivo, p_poliza, p_contratante, p_corredor){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_sinpp_contactos.Recuperar_ConPol",
			"p_args_in": JSON.stringify({
				"p_ejecutivo": p_ejecutivo,
				"p_poliza": p_poliza,
				"p_contratante": p_contratante,
				"p_corredor": p_corredor,
				})
		})
	},

	Recuperar_DatContact(p_email, p_ejecutivo, p_idcontacto){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_sinpp_contactos.Recuperar_DatContact",
			"p_args_in": JSON.stringify({
				"p_ejecutivo": p_ejecutivo,
				"p_idcontacto": p_idcontacto,
				})
		})
	},
	
	eliminar_ConPol(p_email, p_usuario,p_id){
        return axios
        .post('spoc/modppentry', {
            "p_email": p_email,
            "p_metodo": "pkg_sinpp_contactos.eliminar_ConPol",
            "p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_id": p_id
                })
        })
    },
	
	insertar_ConPol(p_email, p_usuario, p_poliza, p_percodigo, p_nombre, p_mail, p_tpaviso, p_tpprocesos){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_sinpp_contactos.insertar_ConPol",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_poliza": p_poliza,
				"p_percodigo": p_percodigo, 
				"p_nombre": p_nombre,
				"p_mail": p_mail,
				"p_tpaviso": p_tpaviso, 
				"p_tpprocesos": p_tpprocesos				
				})
		})
	},
	
	editar_ConPol(p_email, p_usuario, p_id, p_nombre, p_mail, p_tpaviso, p_tpprocesos){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_sinpp_contactos.editar_ConPol",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_id": p_id, 
                "p_nombre": p_nombre, 
                "p_mail": p_mail, 
                "p_tpaviso": p_tpaviso, 
                "p_tpprocesos": p_tpprocesos
				})
		});
	},
	
	actualizar_ConPol(p_email, p_usuario, p_poliza, p_tpaviso){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_sinpp_contactos.actualizar_ConPol",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_poliza": p_poliza, 
                "p_tpaviso": p_tpaviso
				})
		});
	},

}